// Překlady textů v JS (doména djangojs, locale/<jazyk>/LC_MESSAGES/djangojs.po). Katalog /jsi18n/ načítá
// base.html jen pro cs/sk, angličtina jde bez něj. Data se formátují podle jazyka stránky (LOCALE),
// čísla zůstávají s desetinnou tečkou jako v celé aplikaci.
export const LANG = document.documentElement.lang || 'en';
export const LOCALE = LANG === 'en' ? 'en-US' : LANG;  // Intl přijme kód jazyka stránky (cs, de, zh-hans…)

export function gettext(s) {
  return window.django?.gettext ? window.django.gettext(s) : s;
}

export function ngettext(one, many, n) {
  return window.django?.ngettext ? window.django.ngettext(one, many, n) : (n === 1 ? one : many);
}

export function interpolate(s, vars) {
  return s.replace(/%\((\w+)\)s/g, (m, k) => (k in vars ? vars[k] : m));
}
